<template>
  <div class="page-side">
    <div class="content">
      <div class="logo">
        <logo class="logo" :show-text="true"/>
      </div>

      <slot></slot>

      <div class="separator">
        <span class="brand">
          {{ dashboardConfig.identity.applicationName }}
        </span>
      </div>

      <ul class="nav-use-terms">
        <li class="item" v-if="dashboardConfig.legal.terms">
          <a :href="dashboardConfig.legal.terms" target="_blank" class="link">
            Termos de Uso
          </a>
        </li>

        <li class="item" v-if="dashboardConfig.legal.privacy">
          <a :href="dashboardConfig.legal.privacy" target="_blank" class="link">
            Política de privacidade
          </a>
        </li>
      </ul>

      <div class="copyrights">
        &copy; {{ new Date().getFullYear() }} {{ dashboardConfig.identity.applicationName }} - Todos os direitos reservados.
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Logo from '@/support/components/Logo.vue';

export default {
  name: 'PageSide',

  components: {
    Logo,
  },

  computed: {
    ...mapState('dashboard', [
      'dashboardConfig',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  .page-side {
    flex: 1;

    @screen md {
      @apply h-full;
      @apply flex;
      @apply justify-center;
      @apply items-center;
      width: 45%;
      min-width: 45%;
      max-width: 45%;
      flex-direction: column;
      order: 1;
      justify-content: flex-start;
      align-items: stretch;
    }

    > .content {
      @apply w-full;
      @apply p-5;

      @media (min-width: 768px) {
        @apply flex;
        @apply flex-col;
        margin: auto;
        max-width: 420px;
      }

      > .logo {
        > svg {
          height: 80px;
          width: 150px;
        }
      }

      > .separator {
        letter-spacing: 0.1rem;
        margin-top: 30px;
        @apply relative;
        @apply text-center;
        @apply text-sm;
        @apply text-gray-500;
        @apply mb-5;

        > .brand {
          @apply bg-white;
          @apply px-3;
        }

        &:before {
          content: '';
          @apply block;
          @apply w-full;
          height: 1px;
          @apply bg-gray-300;
          @apply absolute;
          top: 50%;
          z-index: -1;
        }
      }

      > .nav-use-terms {
        @apply text-xs;
        @apply mb-5;
        display: flex;
        flex-wrap: wrap;
        list-style: none;

        > .item {
          > .link {
            @apply py-2;
            @apply px-4;
            display: inline-flex;
            align-items: center;
            text-align: left;
          }

          &:first-child {
            > .link {
              @apply pl-0;
            }
          }

          &:last-child {
            > .link {
              @apply pr-0;
            }
          }
        }
      }

      > .copyrights {
        @apply text-sm;
        @apply mb-5;
        @apply text-gray-800;
        opacity: 0.7;
      }
    }
  }
</style>
